import { Button } from '@chakra-ui/button';
import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import { DOWNLOAD_PAGE } from '../../constants/route.const';
// import classes from './styles.module.scss';

export default function ManualAppDownloadButton({ size, children, onClick }) {
  const isSmallSize = size === 'small';
  const navigate = useNavigate();
  return (
    <Button
      size={isSmallSize ? 'sm' : 'md'}
      height={isSmallSize ? '35px' : '48px'}
      variant="solid"
      bgGradient="linear(to-r, #FFC968, #FBE6AE)"
      onClick={onClick ? onClick : () => navigate(DOWNLOAD_PAGE)}
      _hover={{ bgGradient: 'linear(to-r, #FFC968, #FBE6AE)' }}
      // isLoading={isDownloading}
    >
      {children || 'Download'}
    </Button>
  );
}
